/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendUserRegisterDto } from '../../models/backend-user-register-dto';
import { BackendUserRegisterRequestDto } from '../../models/backend-user-register-request-dto';

export interface AccountRegisterCreate$Params {
  body: BackendUserRegisterRequestDto;
}

export function accountRegisterCreate(
  http: HttpClient,
  rootUrl: string,
  params: AccountRegisterCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendUserRegisterDto>> {
  const rb = new RequestBuilder(rootUrl, accountRegisterCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendUserRegisterDto>;
    }),
  );
}

accountRegisterCreate.PATH = '/api/account/register/';
